module.exports = __webpack_public_path__ + "static/media/Elephant1.501d331d.png";